/* Greenleaf — "Text us about this piece". New 13 Oct 2026.
 * On a phone the line [data-text-us] becomes a link that opens the messages app with the
 * piece written in. iOS takes `sms:+1...&body=...`, Android `sms:+1...?body=...`. On a
 * computer (or with no script) the line stays as the plain "Text us at (808) ..." note.
 * Text is written with textContent and the href is built from encodeURIComponent, so a
 * product title cannot inject anything.
 */
(function () {
  'use strict';
  var el = document.querySelector('[data-text-us]');
  if (!el) return;
  var ua = navigator.userAgent || '';
  var ios = /iPhone|iPad|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  var android = /Android/i.test(ua);
  if (!ios && !android) return;
  var tel = el.getAttribute('data-tel'), title = el.getAttribute('data-title') || 'this piece';
  var sku = el.getAttribute('data-sku'), url = el.getAttribute('data-url') || location.href;
  if (!tel) return;
  var custom = el.getAttribute('data-body');
  var body = custom || "Hi, I'm interested in " + title + (sku ? " (" + sku + ")" : "") + " \u2014 " + url;
  var a = document.createElement('a');
  a.className = 'textlink';
  a.href = 'sms:' + tel + (ios ? '&' : '?') + 'body=' + encodeURIComponent(body);
  a.textContent = el.getAttribute('data-label') || 'Text us about this piece';
  el.textContent = '';
  el.appendChild(a);
})();
